import type { Notification } from '$lib/api/restApi';
import { writable, type Writable } from 'svelte/store';
export const notifications: Writable<Notification[]> = writable([] as unknown as Notification[]);
